import { combineReducers, configureStore } from '@reduxjs/toolkit';
import locationsReducer from './locations/locationsSlice';
import selectedLocationReducer from './selectedLocation/selectedLocationSlice';
import userClinic from './userClinic/userClinicSlice';
import userProfile from './userProfile/userProfileSlice';
import locale from './locale/localeSlice';
import token from './token/tokenSlice';

//Step 1
const combinedReducer = combineReducers({
  token: token,
  locale: locale,
  userClinic: userClinic,
  userProfile: userProfile,
  locations: locationsReducer,
  selectedLocation: selectedLocationReducer,
});

//Step 2
const rootReducer = (state, action) => {
  if (action.type === 'RESET') {
    //We are calling this RESET, but call what you like!
    state = {};
  }
  return combinedReducer(state, action);
};

export default configureStore({
  reducer: {
    rootReducer,
  },
});
